import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import VcLogo from '@/components/VcLogo.vue';


Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(VcLogo.name, VcLogo)
